import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {Alert, Badge, Card, Spinner, Table, Button} from "react-bootstrap";
import {reportsApi} from "../../../../api/reports.js";
import {ReportPageShell} from "./ReportLayout.jsx";
import {exportTableToCsv, openTablePrintWindow} from "./exportUtils.js";

function AdminOutageReportPage() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const load = async () => {
        setLoading(true);
        setError("");
        try {
            const resp = await reportsApi.getOutages();
            setData(resp || []);
        } catch (e) {
            console.error(e);
            setError("Failed to load outage report.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, []);

    return (
        <ReportPageShell title="Municipality Outage Report" subtitle="Current online/offline status with reasons.">
            {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
            {loading && (
                <div className="d-flex align-items-center my-4">
                    <Spinner animation="border" size="sm" className="me-2" />
                    <span>Loading...</span>
                </div>
            )}
            {!loading && (
                <Card className="dashboard-panel mt-3" id="outage-table">
                    <Card.Header className="bg-white d-flex justify-content-between align-items-center">
                        <strong>Municipality Status</strong>
                        <div className="d-flex gap-2">
                            <Button size="sm" variant="outline-secondary" onClick={() => exportTableToCsv("outage-table", "municipality_outages.csv")}>Export CSV</Button>
                            <Button size="sm" variant="outline-secondary" onClick={() => openTablePrintWindow("outage-table")}>Export PDF</Button>
                        </div>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <Table hover responsive className="mb-0">
                            <thead>
                                <tr>
                                    <th>Tax Authority</th>
                                    <th>Status</th>
                                    <th>Offline Reason</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((row) => (
                                    <tr key={row.taxAuthorityId}>
                                        <td>{row.taxAuthorityName}</td>
                                        <td>
                                            <Badge bg={row.online ? "success" : "danger"}>{row.online ? "Online" : "Offline"}</Badge>
                                        </td>
                                        <td>{row.offlineReason || "-"}</td>
                                    </tr>
                                ))}
                                {!data.length && (
                                    <tr><td colSpan={3} className="text-center text-muted py-3">No data</td></tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            )}
        </ReportPageShell>
    );
}

export default observer(AdminOutageReportPage);
